import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'

export const StyledProductInformation = styled.div`
  width: 100%;
  text-align: left;
`

export const StyledItemDetails = styled.div({})

export const StyledDocumentsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;

  span {
    font-weight: ${ClinTheme.fontWeights.normal};
    margin-top: 8px;
    display: block;
    height: fit-content;
  }
`

export const Row = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: ClinTheme.space[2],
  marginBottom: ClinTheme.space[2]
})

export const Column = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: ClinTheme.space[3]
})

export const StyledStorage = styled.div({
  marginTop: ClinTheme.space[2]
})

export const StyledNotificationsContainer = styled.div({
  position: 'fixed',
  top: '10px',
  right: '20px',
  zIndex: '9999',
  display: 'flex',
  flexDirection: 'column',
  gap: ClinTheme.space[2],

  '& > div': {
    marginBottom: ClinTheme.space[2]
  }
})
